"use client";

import { useEffect } from "react";

export function KeyboardInset() {
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const root = document.documentElement;

    const update = () => {
      const inset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      // A small inset is just browser chrome; treat a larger one as the keyboard.
      if (inset > 80) {
        root.style.setProperty("--keyboard-inset", `${Math.round(inset)}px`);
        root.style.setProperty("--kb-vvh", `${Math.round(vv.height)}px`);
        root.setAttribute("data-keyboard-open", "");
      } else {
        root.style.setProperty("--keyboard-inset", "0px");
        root.style.removeProperty("--kb-vvh");
        root.removeAttribute("data-keyboard-open");
      }
    };

    update();
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
      root.style.removeProperty("--keyboard-inset");
      root.style.removeProperty("--kb-vvh");
      root.removeAttribute("data-keyboard-open");
    };
  }, []);

  return null;
}
